import { MenuButtonPortal } from "@lazarentertainment/web-design-system/components/menuButton"
import { useFullscreenContext } from "client/components/layout/FullscreenContext"
import { ComponentProps } from "react"

import { SelectPortal } from "./SelectInput"

// These are abstractions of Radix's SelectPortal, MenuButtonPortal, etc
// meant to target the fullscreen element (rather than the default document.body)
// Without this, all content portalled by these radix components won't be visible when in fullscreen mode.

export type SelectPortalWithFullscreenAwarenessProps = ComponentProps<
  typeof SelectPortal
>

export const SelectPortalWithFullscreenAwareness = ({
  children,
  ...props
}: SelectPortalWithFullscreenAwarenessProps) => {
  const { isFullscreen, fullscreenElement } = useFullscreenContext()
  return (
    <SelectPortal
      container={isFullscreen ? fullscreenElement : undefined}
      {...props}
    >
      {children}
    </SelectPortal>
  )
}

export type MenuButtonPortalWithFullscreenAwarenessProps = ComponentProps<
  typeof MenuButtonPortal
>

export const MenuButtonPortalWithFullscreenAwareness = ({
  children,
  ...props
}: MenuButtonPortalWithFullscreenAwarenessProps) => {
  const { isFullscreen, fullscreenElement } = useFullscreenContext()
  return (
    <MenuButtonPortal
      container={isFullscreen ? fullscreenElement : undefined}
      {...props}
    >
      {children}
    </MenuButtonPortal>
  )
}
